import MonthlyFilter from './MonthlyFilter';

export default MonthlyFilter;
